import { render, staticRenderFns } from "./menu-header.component.vue?vue&type=template&id=bc60efc2&scoped=true&"
import script from "./menu-header.component.vue?vue&type=script&lang=ts&"
export * from "./menu-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./menu-header.component.vue?vue&type=style&index=0&id=bc60efc2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc60efc2",
  null
  
)

export default component.exports